import { render, staticRenderFns } from "./smsBalance.vue?vue&type=template&id=244a8cc0"
import script from "./smsBalance.vue?vue&type=script&lang=ts"
export * from "./smsBalance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports